import React from 'react';
import PropTypes from 'prop-types';

import Loading from '../../../components/loading';

import {
  getStorage,
  updateStorage
} from '../../../utils/storage';

import {
  fetchRxHistory,
  fetchDrugNames
} from './fetch-rx-history';

import Summary from '../isolate/gtable_seq/summary';
import GsheetTable from './gtable';
import Navigator from '../../../components/navigator';
import PageHeader from '../../../components/page-header';
import GTable from '../../../components/gsheet/gtable';


export default class RxList extends React.Component {

  static contextTypes = {
    router: PropTypes.shape({
      replace: PropTypes.func.isRequired
    }).isRequired
  };

  constructor() {
    super(...arguments);
    this.state = {
      rawDataCollection: null,
      loading: true,
    };
  }

  async componentDidMount() {
    this.setState({
      loading: true
    });

    const {location: {query}} = this.props;

    let {rawDataCollection} = await getStorage(query.load);
    const {rawSequences} = rawDataCollection;

    if (!rawDataCollection.hasRawRxHistory) {
      rawDataCollection.rawRxHistory = await fetchRxHistory(rawSequences);
    }

    if (!rawDataCollection.checkRxHistoryPatient) {
      rawDataCollection.rawRxHistory = await fetchRxHistory(rawSequences);
    }

    rawDataCollection = await fetchDrugNames(rawDataCollection);

    this.setState({
      rawDataCollection,
      loading: false,
    });

  }

  async handleSave() {
    const {location: {pathname}} = this.props;
    const {rawDataCollection} = this.state;

    const state = {
      pathname: pathname,
      rawDataCollection
    };
    const load = await updateStorage(state);
    return load;
  }

  async handleUpdate(rawDataCollection) {
    this.setState({
      rawDataCollection,
      loading: true
    });

    await fetchDrugNames(rawDataCollection);

    this.setState({
      loading: false,
    });
  }

  async handleSubmit(e) {
    e && e.preventDefault();

    const load = await this.handleSave();
    this.context.router.push({
      pathname: '/wizard/susc-results/opt',
      query: {load}
    });
  }

  render() {
    const {loading} = this.state;

    if (loading) {
      return (<Loading />);
    }

    const {rawDataCollection} = this.state;

    return (
      <div>
        <Navigator
         rawDataCollection={rawDataCollection} />
        <PageHeader references={rawDataCollection.references} />
        <Summary rawDataCollection={rawDataCollection} />
        <GsheetTable
         rawDataCollection={rawDataCollection}
         onUpdate={this.handleUpdate.bind(this)}
         onSubmit={this.handleSubmit.bind(this)}
        />
        <GTable
         spreadsheet_id={rawDataCollection.spreadsheet_id}
         sheet_id={rawDataCollection.sheet_id}
         ></GTable>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/rx-list/index.js